<template>
  <div
    class="cursor-circle"
    :class="[`circle-size-${currentState}`, { 'cursor-hidden': isOverIframe || isOutsideWindow }]"
    :style="containerStyle"
  />
</template>

<script>
export default { name: 'CursorCircle' };
</script>

<script setup>
import { useCursorState } from './useCursorState.js';

const { currentState, containerStyle, isOverIframe, isOutsideWindow } = useCursorState();
</script>

<style scoped lang="scss">
@import './cursor-shared';

// project size defined in shared
</style>
